/**
 * Created by Jie Gao on 2017-06-21.
 */

import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TimelineLite, TweenLite} from "gsap";
import {Wixx} from "../../Wixx";
import {WixxGameConfig} from "../../WixxGameConfig";

export class BigWinNonLoopAnimationContainer extends PIXI.Container {

    private END_ANIMATION_DURATION:number = 1.5;

    private _backgroundDimmer:PIXI.Sprite;
    private _particlesContainer:PIXI.Container;
    private _energyBar:TimelineSprite;
    private _energyBarMask:PIXI.Graphics;
    private _neon_bottom:PIXI.Sprite;
    private _neon_top:PIXI.Sprite;

    private _layer:ScalableLayer;
    private _wantStop:boolean;
    private _baseTimeLine:TimelineLite | null;
    private _neonTimeLine:TimelineLite | null;

    constructor(layer:ScalableLayer) {
        super();
        this._wantStop = false;
        this._layer = layer;
    }

    public initAnimations():void {
        this._backgroundDimmer = this.createDimmer();
        this._layer.addChild(this._backgroundDimmer);

        this._particlesContainer = new PIXI.Container();
        this._layer.addChild(this._particlesContainer);

        this._neon_top = this.createNeonSprite();
        this._neon_bottom = this.createNeonSprite();

        this._energyBar = new TimelineSprite(GameResources.getTextures("stackedReel4Flow"));
        this._energyBar.rotation = Math.PI / 2;
        this._energyBar.blendMode = PIXI.BLEND_MODES.ADD;
        this._energyBar.x = WixxGameConfig.instance.GAME_WIDTH / 2;
        this._energyBar.y = 658;
        this._energyBar.scale.y = 3.5;
        this._energyBar.anchor.set(0.5);
        this._energyBar.hide();

        this._energyBarMask = new PIXI.Graphics();
        this._energyBarMask.beginFill(0xff0000);
        this._energyBarMask.drawRect(0, this._energyBar.y - this._energyBar.width / 2, GameConfig.instance.GAME_WIDTH, this._energyBar.width);
        this._energyBarMask.visible = false;
        this._layer.addChild(this._energyBarMask);
    }

    private createDimmer():PIXI.Sprite {
        let graphics = new PIXI.Graphics();
        graphics.beginFill(0x000000);
        graphics.drawRect(0, 0, WixxGameConfig.instance.GAME_WIDTH, WixxGameConfig.instance.GAME_HEIGHT);

        const sprite = new PIXI.Sprite();
        sprite.addChild(graphics);
        sprite.alpha = 0;
        return sprite;
    }

    private createNeonSprite():PIXI.Sprite {
        const sprite:PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("bigWin_neon_foreground")[0]);
        sprite.x = 0;
        sprite.y = 0;
        sprite.alpha = 0;
        sprite.anchor.set(0);
        sprite.blendMode = PIXI.BLEND_MODES.ADD;
        return sprite;
    }

    public startAnimation():void {
        this._wantStop = false;
        this._baseTimeLine = new TimelineLite();
        this._energyBar.show();
        this._energyBar.alpha = 0;

        this._layer.addChild(this._neon_bottom);
        this._layer.addChild(this._neon_top);
        this._layer.addChild(this._energyBar);
        this._energyBar.mask = this._energyBarMask;

        if(Wixx.particles != null) {
            Wixx.particles.play(1.5 * 1.8, this._particlesContainer, this._layer)
        }

        this._baseTimeLine.add([
            TweenLite.fromTo(this._backgroundDimmer, 0.5, {alpha : 0}, {alpha : 0.7}),
            TweenLite.fromTo(this._energyBar, 0.5, {alpha : 0}, {alpha : 1})
        ]);
        this._baseTimeLine.add(() => {this._energyBar.playLoop();}, '0');
    }

    public animateNeon(duration:number):void {
        if(this._baseTimeLine !== null && !this._wantStop) {
            if(!this._neonTimeLine) {
                this._neonTimeLine = new TimelineLite({paused : true});
            } else {
                this._neonTimeLine.clear();
            }
            for(let i = 0; i < 9; i++) {
                this._neonTimeLine.to(this._neon_bottom, duration / 8, {alpha : i % 2});
            }
            this._neonTimeLine.add(TweenLite.fromTo(this._neon_top, duration, {alpha : 0}, {alpha : 1}), '0');
            this._neonTimeLine.play();
        }
    }

    public stopAnimation():void {
        const duration:number = this.END_ANIMATION_DURATION;
        this._wantStop = true;
        if(this._neonTimeLine !== null && this._neonTimeLine.isActive()) {
            this._neonTimeLine.pause();
            this._neonTimeLine.kill();
            this._neonTimeLine = null;
        }
        if(this._baseTimeLine !== null && this._baseTimeLine.isActive()) {
            this._baseTimeLine.pause();
            this._baseTimeLine.kill();
        }
        this._neon_bottom.alpha = 0;
        TweenLite.fromTo(this._neon_top, duration, {alpha : 1}, {alpha : 0});
        TweenLite.fromTo(this._backgroundDimmer, duration, {alpha : 1}, {alpha : 0});
        TweenLite.fromTo(this._energyBar, duration, {alpha : 1}, {alpha : 0});
    }

    public reset() {
        this._energyBar.stopLoop();
        this._energyBar.hide();
        this._neon_bottom.alpha = 0;
        this._neon_top.alpha = 0;
        this._backgroundDimmer.alpha = 0;
        if(this._baseTimeLine !== null && this._baseTimeLine.isActive()) {
            this._baseTimeLine.pause();
            this._baseTimeLine.kill();
            this._baseTimeLine = null;
        }
        this._layer.removeChild(this._neon_bottom);
        this._layer.removeChild(this._neon_top);
        this._layer.removeChild(this._energyBar);
    }
}